import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { mergeMap, catchError, of, map } from 'rxjs'
import {
  route_to_action,
  show_display_id_after_created_action,
  show_success_msg_after_updation_action,
  show_error_action
} from '../action/common/common.action'
import {
  fetch_dashboard_data,
  fetch_dashboard_data_success,
  fetch_government_business_details,
  fetch_government_business_details_success,
  load_government_business_summary_action,
  load_government_business_summary_success_action,
  save_government_business_action,
  save_government_business_success_action,
  update_government_business_action,
  update_government_business_success_action
} from '../action/government-business.action'
import { GovernmentBusinessService } from 'src/app/services/government/government-business.service'

@Injectable()
export class GovernmentBusinessEffect {
  constructor(private actions$: Actions, private governmentService: GovernmentBusinessService) {}

  fetch_government_dashboard_data$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_dashboard_data),
      mergeMap(action =>
        this.governmentService.invokeDashboardApi(action.days, action.sortBy, action.sortOrder).pipe(
          mergeMap(response => [fetch_dashboard_data_success(response)]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  save_government_business_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_government_business_action),
      mergeMap(({ governmentBusiness, files, routeTo }) =>
        this.governmentService.callSaveApi(governmentBusiness, files).pipe(
          mergeMap(response => [
            save_government_business_success_action({ governmentBusiness: response, routeTo }),
            route_to_action({ routeTo }),
            show_display_id_after_created_action({ moduleName: 'Government Business', displayId: response?.displayId })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_government_business_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_government_business_details),
      mergeMap(({ id }) =>
        this.governmentService.callDetailsApi(id).pipe(
          mergeMap(governmentBusiness => [fetch_government_business_details_success({ governmentBusiness })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_government_business_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(update_government_business_action),
      mergeMap(({ governmentBusiness, id, files, routeTo }) =>
        this.governmentService.callUpdateApi(governmentBusiness, id, files).pipe(
          mergeMap(governmentBusiness => [
            update_government_business_success_action({ governmentBusiness, routeTo }),
            route_to_action({ routeTo }),
            show_success_msg_after_updation_action({
              moduleName: 'Government Business'
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  load_government_business_summary_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_government_business_summary_action),
      mergeMap(data =>
        this.governmentService.invokeGovernmentSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(governmentBusiness =>
            load_government_business_summary_success_action({ governmentBusiness: governmentBusiness })
          ),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
